module.exports = __webpack_public_path__ + "img/portrait-stories.afaf0348.png";